module.exports = __webpack_public_path__ + "static/media/ai2html-graphic-mobile320.da5b0300.gif";